import { PublicClientApplication, Configuration, BrowserCacheLocation } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: "6d3d4c7e-e55c-4771-8498-f1c7370db1c6",
    authority:
      "https://login.microsoftonline.com/66093ada-30c8-4aeb-9b9e-47ec1186da88",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    // `navigateToLoginRequestUrl` was dropped from BrowserAuthOptions in
    // @azure/msal-browser v5 (this workspace resolves 5.10.1) — the property is
    // absent from the v5 typings and ignored at runtime, so removing it is a
    // no-op for the shipped bundle; it only broke the build. Iframe redirects
    // stay handled by `system.allowRedirectInIframe` below. 2026-07-27.
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    // Allow MSAL to handle redirect promises inside iframes (Teams tab)
    allowRedirectInIframe: true,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
